import React from 'react';
import { Header } from '../../01-molecules/header/header.tsx';
import { Footer } from '../../01-molecules/footer/footer.tsx';
import { Ad } from '../../00-atoms/ad/ad.tsx';
import { DisplacedStickyAds } from '../../00-atoms/ad/displaced-sticky-ad.tsx';
import { Search } from '../../../../../patterns/01-molecules/search/search.tsx';
import { classList } from '../../../../../utils/string.ts';
import { Cookie } from '../../../../../utils/cookie.ts';
import { ToTopButton } from '../../../../../patterns/00-atoms/to-top-button/to-top-button.tsx';

export type PageProps = {
  withLeftAd?: boolean;
  withRightAd?: boolean;
  withHeaderAd?: boolean;
  modalRef?: any;
  showAds?: boolean;
  toTopButton?: boolean;
};

export const Page: React.FunctionComponent<React.PropsWithChildren<PageProps>> = props => {
  const { withLeftAd, withRightAd, withHeaderAd, showAds, toTopButton = false } = props;
  const hasDisplacedStickyAd = withLeftAd || withRightAd;
  const [showSearch, setShowSearch] = React.useState(false);
  const [isModalOpen, setIsModalOpen] = React.useState(
    props.modalRef?.current?.isModalOpen ?? false
  );
  const abTabSetup = new Cookie('sk-AB-tabsetup').value ?? '0';

  if (abTabSetup === '2' || abTabSetup === '3') {
    React.useEffect(() => {
      const interval = setInterval(() => {
        setIsModalOpen(props.modalRef?.current?.isModalOpen);
      }, 100); // Polling, besser wäre ein Event/Callback

      return () => clearInterval(interval);
    }, [props.modalRef]);
  }

  const content = (
    <div
      className={classList(
        'md:border-sk-grey-500 m-auto max-w-244 md:rounded-3xl md:border-1',
        new Cookie('sk-AB-adsetup').value == '4' && 'md:my-8'
      )}
    >
      {props.children}
    </div>
  );

  return (
    <>
      <div className="bg-sk-grey-200 mt-12">
        <div className="fixed top-0 right-0 left-0 z-50">
          <Header showSearch={showSearch} setShowSearch={setShowSearch} />
        </div>

        {showSearch && <Search />}

        {withHeaderAd && (
          <>
            <Ad
              adId="sk_header"
              disclaimer={false}
              minHeightClass="min-h-[100px] md:min-h-[250px] md:max-w-[970px]"
              className={classList(
                isModalOpen &&
                  abTabSetup === '3' &&
                  'fixed -top-4 z-(--z-index-ad-skyscraper) bg-transparent'
              )}
            />
            {isModalOpen && abTabSetup === '3' && (
              <div className="block min-h-[132px] w-full bg-transparent md:min-h-[282px] md:max-w-[970px]" />
            )}
          </>
        )}

        {hasDisplacedStickyAd ? (
          <DisplacedStickyAds leftAd={true} rightAd={true} isModalOpen={isModalOpen}>
            {content}
          </DisplacedStickyAds>
        ) : (
          <div className={classList(!showAds && 'py-4')}>{content}</div>
        )}

        {showAds && <Ad adId="sk_footer" minHeightClass="min-h-[480px] md:min-h-[250px]" />}

        <Footer />
        {toTopButton && <ToTopButton />}
      </div>
      {/* {process.env.ENVIRONMENT !== 'prod' && <TestingTool />} */}
    </>
  );
};
